"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ClassUtil = {
    new_instance: function (_class) {
        try {
            return new _class();
        }
        catch (error) {
            return error._instance;
        }
    },
};
exports.default = ClassUtil;



//////////////////
// WEBPACK FOOTER
// ../proteus/dist/util/ClassUtil.js
// module id = 3
// module chunks = 0 1